// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"592":"AgGridTable","642":"ExtensionPropertyWrap"}[chunkId] + ".min.css";
};